import React, { useState } from "react";
import { ArrowRight } from "lucide-react";
import DeleteConfirmModal from "./DeleteConfirmModal";

const initialPosts = Array.from({ length: 3 }).map((_, i) => ({
  id: i + 1,
  title: "Cappadocia: A Fairytale Destination Above the Clouds",
  desc: "Cappadocia, located in the heart of Turkey, is famous for its surreal landscapes, fairy chimneys, and colorful...",
  date: "May 20, 2026",
  readTime: "8 min read",
  status: "Published",
  image: "/img/blog/featured-post.svg",
}));

export default function RecentlyPublished() {
  const [posts, setPosts] = useState(initialPosts);
  const [pendingDeleteId, setPendingDeleteId] = useState(null);

  const handleConfirmDelete = () => {
    setPosts((prev) => prev.filter((post) => post.id !== pendingDeleteId));
    setPendingDeleteId(null);
  };

  return (
    <section className="max-w-7xl mx-auto px-6 sm:px-10 py-6">
      <div className="flex items-center justify-between mb-5">
        <h2 className="text-2xl font-extrabold text-slate-900">
          Recently Published
        </h2>
        <a
          href="/blog"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#7209B7] hover:text-[#5a07a0] transition-colors"
        >
          View all Blogs <ArrowRight className="w-4 h-4" />
        </a>
      </div>

      <div className="bg-white border border-slate-100 shadow-sm rounded-2xl overflow-hidden mb-6">
        {posts.map((post, i) => (
          <div
            key={post.id}
            className={`flex items-center gap-5 p-4 sm:p-5 ${
              i !== posts.length - 1 ? "border-b border-slate-100" : ""
            }`}
          >
            <div className="w-24 h-16 sm:w-28 sm:h-20 rounded-xl overflow-hidden bg-slate-200 shrink-0">
              <img
                src={post.image}
                alt={post.title}
                className="w-full h-full object-cover"
              />
            </div>

            <div className="flex-1 min-w-0">
              <h4 className="font-semibold text-slate-900 text-sm sm:text-base leading-snug mb-1 truncate">
                {post.title}
              </h4>
              <p className="text-sm text-slate-500 leading-relaxed mb-2 line-clamp-2 max-w-2xl">
                {post.desc}
              </p>
              <p className="text-xs text-slate-400">
                {post.date} <span className="mx-1">&bull;</span> {post.readTime}
              </p>
            </div>

            <div className="flex items-center gap-3 shrink-0">
              <span className="text-xs font-semibold text-emerald-600 bg-emerald-50 px-3 py-1.5 rounded-full">
                {post.status}
              </span>
              <button
                type="button"
                aria-label="Delete post"
                onClick={() => setPendingDeleteId(post.id)}
                className="w-9 h-9 flex items-center justify-center hover:opacity-80 transition-opacity shrink-0"
              >
                <img src="/img/blog/Delete.svg" alt="" className="w-9 h-9" />
              </button>
            </div>
          </div>
        ))}

        {posts.length === 0 && (
          <p className="text-sm text-slate-400 text-center py-8">
            No published blogs yet.
          </p>
        )}
      </div>

      <DeleteConfirmModal
        open={pendingDeleteId !== null}
        onCancel={() => setPendingDeleteId(null)}
        onConfirm={handleConfirmDelete}
      />
    </section>
  );
}
